import Typography from "@mui/material/Typography";

import { Container, StatsScore, StatsTitle } from "./stats.styled";
import { StatsProps } from "./stats.type";

const Stats = ({ title, stat, color }: StatsProps) => {
  return (
    <Container>
      <StatsScore color={color}> {stat} </StatsScore>
      <StatsTitle color={color}>{title} </StatsTitle>
    </Container>
  );
};

export default Stats;
